import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Logger } from '../../../common/utils';
import { ATLASSIAN_CONSENT_COOKIE_KEY, ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY, ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY } from '../../../constants';
import { fetchCurrentLocale, saveConsentPreferences } from '../../../services/consent-hub-service';
import { getConsentedUnderPrivacyActPrefs, getDefaultPrefs } from '../../../services/consent-hub-service/utils';
import { ConsentPreference } from '../../../types';
import { getCookie } from '../get-cookie';
import { overrideLocaleForLiveTesting } from '../override-with-testing-cookies';
import { setConsentTokenCookie, setConsentTokenFallbackCookie, setShouldShowBannerCookie } from '../set-required-consent-cookies';
import { packUserPreferences, unpackUserPreferencesCookie } from '../transformer';
export var mergeConsentUpdates = function mergeConsentUpdates(updatedPreferences, currentLocale) {
  // updatedPreferences coming from the UI may only have the cookie consent bits, rather than the V002 bits

  // Take existing token and merge with updated preferences if it exists
  // If it does not exist, we'll need to create a new token with the `consentedInXX` bits
  var existingPrefs = getCookie(ATLASSIAN_CONSENT_COOKIE_KEY);
  var fallbackPrefs = getCookie(ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY);
  var defaultPrefs = getDefaultPrefs(currentLocale);
  if (existingPrefs) {
    // Unpack them to proper format, V002 if we're here
    var unpackedExistingPrefs = unpackUserPreferencesCookie(existingPrefs);
    // Merge them with defaults to capture any missed options (shouldn't have any if we have existing consent token),
    // with existing ones, and with the new changes
    if (unpackedExistingPrefs) {
      var _v002ContextualProperties = _objectSpread(_defineProperty({}, ConsentPreference.ConsentDataUnavailable, !!(unpackedExistingPrefs !== null && unpackedExistingPrefs !== void 0 && unpackedExistingPrefs[ConsentPreference.ConsentDataUnavailable])), getConsentedUnderPrivacyActPrefs(currentLocale));
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultPrefs), unpackedExistingPrefs), _v002ContextualProperties), updatedPreferences);
    }
    return _objectSpread(_objectSpread({}, defaultPrefs), updatedPreferences);
  }
  // If we don't have existing prefs, this is likely a first time save for this domain
  // However, we could have a fallback token, meaning they've consented previously within the past year

  if (fallbackPrefs) {
    // TODO: We should use this as the existing prefs, right?
  }

  // Legitimately no existing prefs, and locale is unknown/missing,
  // Thus we have no way to know where they're consenting from, and we should just default + updated

  var v002ContextualProperties = _objectSpread(_defineProperty({}, ConsentPreference.ConsentDataUnavailable, false), getConsentedUnderPrivacyActPrefs(currentLocale));
  return _objectSpread(_objectSpread(_objectSpread({}, defaultPrefs), v002ContextualProperties), updatedPreferences);
};
export var setConsentToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(updatedPreferences, displayedTextMap, shouldSkipPersisting) {
    var currentLocale, testingLocale, mergedPrefs, consentToken, _consentToken;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // TODO: JELLY-581: Enhance this to properly save to ConsentHub (displayedText)
          // currentLocale is used to determine the `consentedInXX` bits
          currentLocale = getCookie(ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY);
          if (currentLocale) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return fetchCurrentLocale();
        case 4:
          currentLocale = _context.sent;
        case 5:
          testingLocale = overrideLocaleForLiveTesting(currentLocale);
          mergedPrefs = mergeConsentUpdates(updatedPreferences, testingLocale || currentLocale);
          _context.prev = 7;
          if (shouldSkipPersisting) {
            _context.next = 11;
            break;
          }
          _context.next = 11;
          return saveConsentPreferences(mergedPrefs, displayedTextMap);
        case 11:
          // Attempts to save the newly updated preferences object
          // Can only saved when a user is logged in, so this should error out if unauthed
          // On a successful save, transform the prefs object into a formatted consentToken bit string
          // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
          consentToken = packUserPreferences(mergedPrefs);
          setConsentTokenCookie(consentToken);
          setConsentTokenFallbackCookie(consentToken);
          setShouldShowBannerCookie(consentToken, currentLocale);
          _context.next = 23;
          break;
        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](7);
          // If we fail to save to ConsentHub, we should store in the FALLBACK COOKIE instead
          // This allows us to still track consents when ConsentHub is down > 10 minute expiry
          // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
          Logger.error('Token failed to save');
          _consentToken = packUserPreferences(_objectSpread(_objectSpread({}, mergedPrefs), {}, _defineProperty({}, ConsentPreference.ConsentDataUnavailable, true)));
          setConsentTokenFallbackCookie(_consentToken);
          setShouldShowBannerCookie(_consentToken, currentLocale);
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 17]]);
  }));
  return function setConsentToken(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();